// removed by extract-text-webpack-plugin
module.exports = {"termsAndConditionsIcon":"_3R1smJ3C1Rm0-zP0m8JCQW","promoTermsAndConditionsIcon":"_1RAPRSxE01Pnu-5FFiUdnZ","promoHeading":"E2ptMbbaUFE_T-Dn6JktF","promoSubHeading":"_1GApb2t6z0mfbRt58BJ2Qs","textBox":"h6BN7aOzh2NLoGgFzDEZH","myOffersIconDiv":"_2SdHyHUYAr9tUCXl16CPwq","myOffersIcon":"_3WyCrpqPAxmTE3gZIKwlFi","doNotShowText":"_1-PvJj1HKZJ91gh0SqhtIa","viewOffersButton":"_3rPhttqjSEdS2nE_-ITR6","viewOffersButtonText":"_2EWJwnNMJuDY06Mr_RWHnH","label":"_1m7MXw_E2NCCjMhdiSuIFu","checkboxs":"_2G4kuwfUbczfKtuRY78r1t","clickLabel":"_20mgXVgPWeROer4nyGsGSC","pageDocument":"_2Fx1WKjFPPmbmNUPJrBKIk"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/termsAndConditions.css
// module id = 901
// module chunks = 0